import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = (props: SvgProps) => (
  <Svg width="16" viewBox="0 0 16 16" fill="none">
    <Path
      d="M7.24988 12.5C10.1494 12.5 12.4999 10.1495 12.4999 7.25C12.4999 4.35051 10.1494 2 7.24988 2C4.35038 2 1.99988 4.35051 1.99988 7.25C1.99988 10.1495 4.35038 12.5 7.24988 12.5Z"
      stroke={props.color ? props.color : '#2B2845'}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M10.962 10.9629L13.9996 14.0004"
      stroke={props.color ? props.color : '#2B2845'}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </Svg>
);

const SearchIcon = memo(SvgComponent);
export default SearchIcon;
